import { fetchPost } from '../Service/ApiService'
import { authmodel } from '../Provider/AuthProvider';

export const activeRefundPaymentProof = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`refundpaymentproof/bulckapprove`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};

export const rejectRefundPaymentProof = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`refundpaymentproof/bulckdecline`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};



export const activeRefundPaymentProofNew = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`refundpaymentproofnew/bulckapprove`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};

export const rejectRefundPaymentProofNew = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`refundpaymentproofnew/bulckdecline`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};






